export default __webpack_public_path__ + "static/media/coming-soon-v2-img.2b6ec26b.png";